module.exports = __webpack_public_path__ + "menu_1.6e3b0210.png";